export const authStrings = {
  challenges: {
    newPassword: "NEW_PASSWORD_REQUIRED",
  },
  errors: {
    signIn: "Could not sign in.",
    changePassword: "Could not update password.",
  },
  headers: {
    login: "Log in",
    changePassword: "Change password",
    completePassword: "Complete password reset",
  },
  labels: {
    email: "Email",
    password: "Password",
    login: "Log in",
    resetPassword: "Reset your password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    confirm: "Confirm",
    signingIn: "Signing in...",
    code: "Code",
    submit: "Submit",
    returnToLogin: "Return to login",
  },
  text: {
    receiveCode:
      "Enter your email address below to receive a confirmation code.",
    legal: `\u00A9 ${new Date().getFullYear()} Pulsion Technology Limited. All rights reserved.`,
  },
};
